export default "__VITE_ASSET__CtPQeX6r__"